/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { i as isFunction_1 } from '../../../_chunks/dep-8d19eb1a.mjs';
import { i as isNumber_1 } from '../../../_chunks/dep-961339ce.mjs';
import '../../../_chunks/dep-eba62589.mjs';
import '../../../_chunks/dep-7d9e11c8.mjs';
import '../../../_chunks/dep-ae1abe1d.mjs';
import '../../../_chunks/dep-16e2f1a5.mjs';
import '../../../_chunks/dep-a6022780.mjs';

function isRowSelectedDisabled(selectColumn, row, rowIndex) {
  var disabled = isFunction_1(selectColumn.disabled) ? selectColumn.disabled({
    row: row,
    rowIndex: rowIndex
  }) : selectColumn.disabled;
  if (selectColumn.checkProps) {
    if (isFunction_1(selectColumn.checkProps)) {
      disabled = disabled || selectColumn.checkProps({
        row: row,
        rowIndex: rowIndex
      }).disabled;
    } else if (selectColumn.checkProps === "object") {
      disabled = disabled || selectColumn.checkProps.disabled;
    }
  }
  return !!disabled;
}
function getColWidthAttr(col, attrKey) {
  var attr = col[attrKey];
  return isNumber_1(attr) ? attr : parseFloat(attr);
}

export { getColWidthAttr, isRowSelectedDisabled };
//# sourceMappingURL=utils.mjs.map
